/**
 * Confirm Dialog Component
 * Extracted from App.js - Phase 7H Frontend Refactor
 * Reusable confirmation dialog for destructive actions
 */

const ConfirmDialog = ({ isOpen, title, message, confirmLabel, onConfirm, onCancel, isDestructive }) => {
  if (!isOpen) return null;
  
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal confirm-dialog" onClick={e => e.stopPropagation()}>
        <h3>{title}</h3>
        <p className="confirm-message">{message}</p>
        <div className="modal-actions">
          <button className="btn-secondary" onClick={onCancel}>Cancel</button>
          <button className={isDestructive ? "btn-danger" : "btn-primary"} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
